import * as React from 'react';

import type { RenderElementProps } from 'slate-react';

import type { TextElement } from 'bundles/cml/shared/types/elementTypes';

const Paragraph = ({ element, attributes, children }: RenderElementProps) => {
  const { variant } = element as TextElement;

  return (
    <p {...attributes} {...(variant && { 'data-text-variant': variant })}>
      {children}
    </p>
  );
};

export default Paragraph;
